import { LearningItem } from '../../models/LearningItem'

export default function learningItemTimeInvested(learningItem?: LearningItem) {
  return learningItem?.learningProgress?.secondsTracked || learningItem?.learningProgress?.secondsInvested || 0
}
